<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
    <div class="content-inner">
        <div class="form-body" [formGroup]="censusForm">
            <ng-template [ngIf]="prevShiftRecord">
                <section *ngIf="!hasCompletePreviousShiftRecord()" class="workflow-input-group">
                    <div class="warning info">* The information recorded during the previous block is incomplete.</div>
                    <div class="workflow-input">
                    <input type="number" min="0" attr.aria-label="Starting Census for Previous Block" formControlName="previousCensusControl">
                    <span class="display-label">Starting Census for Previous Block <span *ngIf="!isStartingCensusValid()" class="warning inline"><span class="icon-warning2"></span> Must be between {{shiftRecord.costCenter.inpatientConfiguration.minCensus}} and {{shiftRecord.costCenter.inpatientConfiguration.maxCensus}}</span></span>
                    </div>
                </section>
                <section *ngIf="hasCompletePreviousShiftRecord()" class="workflow-input-group">
                    <div class="workflow-input">
                        <input type="number" attr.aria-label="Starting Census for Previous Block" disabled [value]="prevShiftRecord.patientCensusRecord.patients">
                        <span class="display-label">Starting Census for Previous Block</span>
                    </div>
                    <div class="workflow-input" *ngIf="prevShiftRecord.patientCensusRecord.midnight">
                        <input type="number" attr.aria-label="Midnight Census for Previous Block" disabled [value]="prevShiftRecord.patientCensusRecord.midnight">
                        <span class="display-label">Midnight Census for Previous Block</span>
                    </div>
                </section>
                <section class="workflow-input-group">
                    <div class="workflow-input-labels">
                        <span>Projected</span>
                        <span>Actual</span>
                    </div>
                    <div class="workflow-input">
                    <input type="text" disabled attr.aria-label="Projected Admits" [value]="projectedChurnValue('admits')">
                        <input type="number" min="0" attr.aria-label="Actual Admits" formControlName="admits">
                        <span class="display-label">Admits</span>
                    </div>            
                    <ng-template [ngIf]="prevShiftRecord.costCenter.inpatientConfiguration.transfers">
                        <div class="workflow-input">
                            <input type="text" disabled attr.aria-label="Projected Transfers In (+)" [value]="projectedChurnValue('transfersIn')">
                            <input type="number" min="0" attr.aria-label="Actual Transfers In (+)" formControlName="transfersIn">
                            <span class="display-label">Transfers In (+)</span>
                        </div>  
                        <div class="workflow-input">
                            <input type="text" disabled attr.aria-label="Projected Transfers Out (-)" [value]="projectedChurnValue('transfersOut')">
                            <input type="number" min="0" attr.aria-label="Actual Transfers Out (-)" formControlName="transfersOut">
                            <span class="display-label">Transfers Out (-)</span>
                        </div>
                    </ng-template>
                    <div class="workflow-input">
                        <input type="text" disabled attr.aria-label="Projected Discharges" [value]="projectedChurnValue('discharges')">
                        <input type="number" min="0" attr.aria-label="Actual Discharges" formControlName="discharges">
                        <span class="display-label">Discharges</span>
                    </div>        
                    <div class="workflow-input totals">
                        <input type="text" disabled attr.aria-label="Previous Projected Census" [value]="previousCensusValue()">
                        <input type="text" disabled attr.aria-label="Updated Census" [value]="updatedCensus">
                        <span class="display-label">Total Census 
                        <span *ngIf="!isCensusFormValid()" class="warning inline"><span class="icon-warning2"></span> Please enter positive patient counts in each field.</span>
                        <span *ngIf="isCensusFormValid() && !isValid()" class="warning inline"><span class="icon-warning2"></span> Must be between {{shiftRecord.costCenter.inpatientConfiguration.minCensus}} and {{shiftRecord.costCenter.inpatientConfiguration.maxCensus}}</span></span>
                    </div>

                    <div class="warning info" *ngIf="!hasCompletePreviousShiftRecord()">* The information recorded during the previous block is incomplete</div>
                </section>
                <section *ngIf="hasCompletePreviousShiftRecord()" class="workflow-input-group">
                    <a (click)="displayStaffingPlan = true">
                        <span class="icon-eye"></span> Review Staffing Plan for {{formatShiftBlockTime()}}
                    </a>
                    <ng-template [ngIf]="displayStaffingPlan">
                        <ng-template [ngIf]="prevShiftRecord.costCenter.variableJobTitles.length">
                            <div class="display-label">Variable Staff</div>
                            <div class="workflow-input-labels">
                                <span>Target</span>
                                <span>Actual</span>
                            </div>
                            <div class="workflow-input" *ngFor="let varStaff of prevShiftRecord.costCenter.variableJobTitles">
                                <input type="text" disabled [attr.aria-label]="'Target' + varStaff.abbreviation" [value]="getRecommendedStaffCount(varStaff.id)">
                                <input type="text" disabled [attr.aria-label]="'Actual' + varStaff.abbreviation" [value]="getActualStaffCount(varStaff.id)">
                                <span class="display-label">{{ varStaff.abbreviation }}</span>
                            </div>
                        </ng-template>
                        <ng-template [ngIf]="prevShiftRecord.costCenter.fixedJobTitles.length">
                            <div class="display-label">Fixed Staff</div>
                            <div class="workflow-input-labels" *ngIf="review">
                                <span>Target</span>
                                <span>Actual</span>
                            </div>
                            <div class="workflow-input" *ngFor="let fixed of prevShiftRecord.costCenter.fixedJobTitles">
                                <input type="text" disabled [attr.aria-label]="'Target' + fixed.abbreviation" [value]="getRecommendedStaffCount(fixed.id)">
                                <input type="text" disabled [attr.aria-label]="'Actual' + fixed.abbreviation" [value]="getActualStaffCount(fixed.id)">
                                <span class="display-label">{{ fixed.abbreviation }}</span>
                            </div>
                        </ng-template>
                    </ng-template>
                </section>
            </ng-template>
            <ng-template [ngIf]="!prevShiftRecord">
                <div class="warning info">This cost center has no previous shift block.  What is the starting census?</div>
                <section class="workflow-input-group">
                    <div class="workflow-input">
                        <input type="number" min="0" attr.aria-label="Starting Census" formControlName="startingCensus">
                        <span class="display-label">Starting Census <span *ngIf="!isStartingCensusValid()" class="warning inline"><span class="icon-warning2"></span> Must be between {{shiftRecord.costCenter.inpatientConfiguration.minCensus}} and {{shiftRecord.costCenter.inpatientConfiguration.maxCensus}}</span></span>
                    </div>
                </section>
            </ng-template>
        </div>
    </div>
</ng-template>
